/* eslint-disable no-restricted-imports */
import { format, formatRelative, Locale } from 'date-fns'
import i18next from 'i18next'

import { LOCALES } from '../constants/locales'

const getLocale = (): Locale => {
  const language = (i18next.language || 'pt') as keyof typeof LOCALES
  return LOCALES[language] || LOCALES.pt
}

export const formatDate = (
  date: Date | number,
  formatStr: string = 'PP',
): string => {
  return format(date, formatStr, {
    locale: getLocale(),
  })
}

export const formatRelativeDate = (
  date: Date | number,
  baseDate: Date = new Date(),
): string => {
  return formatRelative(date, baseDate, {
    locale: getLocale(),
  })
}
